import Stevenson from "../images/teach/teachers/Stevenson.png";
import Julia from "../images/teach/teachers/Julia.png";
import Robert from "../images/teach/teachers/Robert.png";
import Brinda from "../images/teach/teachers/Brinda.png";
import Samantha from "../images/teach/teachers/Samantha.png";

export const TeachData = [
  {
    id: 1,
    speciality: "Python, Machine Learning",
    star: "4.6",
    students: "2,567",
    courses: "32",
    img: Stevenson,
    path: "./courses",
    name: "Stevenson",
  },
  {
    id: 2,
    speciality: "Javascript, MongoDB",
    star: "4.8",
    students: "739,371",
    courses: "8",
    img: Julia,
    path: "./courses",
    name: "Julia Roberts",
  },
  {
    id: 3,
    speciality: "React, React-Hooks",
    star: "4.3",
    students: "1,567,631",
    courses: "26",
    img: Robert,
    path: "./courses",
    name: "Robert Hendricks",
  },
  {
    id: 4,
    speciality: "React, Redux",
    star: "4.1",
    students: "762,593",
    courses: "29",
    img: Brinda,
    path: "./courses",
    name: "Brinda Mathews",
  },
  {
    id: 5,
    speciality: "Web Development, MySQL",
    star: "4.9",
    students: "1.092,567",
    courses: "5",
    img: Samantha,
    path: "./courses",
    name: "Samantha S",
  },
];
